import { render, staticRenderFns } from "./ClientCredentials.vue?vue&type=template&id=00d41670&"
import script from "./ClientCredentials.vue?vue&type=script&lang=js&"
export * from "./ClientCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports